var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comments-section" },
    [
      !_vm.isLoadingComments
        ? [
            _vm.comments.length !== 0
              ? _vm._l(_vm.comments, function(comment) {
                  return _c("comment", {
                    staticClass: "comments-section-comment",
                    attrs: {
                      id: comment.id,
                      content: comment.content,
                      created: comment.created,
                      "created-by": comment.createdByName,
                      "is-editable": comment.isEditable,
                      "is-seen": comment.isSeen,
                      "sub-type": comment.subType,
                      "related-id": _vm.relatedId
                    },
                    on: { "editor-opened": _vm.onEditorOpened }
                  })
                })
              : _c("div", { staticClass: "text-center" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.resource("JourneyBuilder_Comments_NoComments")
                      ) +
                      "\n        "
                  )
                ])
          ]
        : _c("loader", { staticClass: "loader" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }